module.exports = __webpack_public_path__ + "static/media/daimler-wharf-2.11440e31.jpg";